import type { HTMLAttributes } from 'react';

export interface SkeletonProps extends HTMLAttributes<HTMLElement> {
  width?: string | number;
  height?: string | number;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  /** Znacznik: `span` tam, gdzie `div` byłby niedozwolony w rodzicu (np. wewnątrz `<button>`). */
  as?: 'div' | 'span';
}

const ROUNDED: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

export function Skeleton({
  width,
  height = '1rem',
  rounded = 'md',
  as: Tag = 'div',
  className,
  style,
  ...rest
}: SkeletonProps) {
  return (
    <Tag
      aria-hidden="true"
      className={[
        'animate-pulse bg-bg-tertiary',
        Tag === 'span' ? 'inline-block align-middle' : '',
        ROUNDED[rounded],
        className ?? '',
      ].join(' ')}
      style={{ width, height, ...style }}
      {...rest}
    />
  );
}
